import { Center } from '@chakra-ui/react'
import React from 'react'
import LoadingWrapper from '../LoadingWrapper/LoadingWrapper'

export default function DocumentViewer({ file, loading }) {
    return (
        <LoadingWrapper {...loading}>
            <Center>{file.name}</Center>
        </LoadingWrapper>
    )
}
